export const InterfaceModule = {
  state: {
    sidebarShowing: false,
    showLoadingOverlay: false,
    loadingMessage: "",
  },

  getters: {
    showLoadingOverlay: (state) => state.showLoadingOverlay,
    loadingMessage: (state) => state.loadingMessage,
  },

  actions: {
    setShowLoadingOverlay({ commit }, payload) {
      commit("SET_SHOW_LOADING_OVERLAY", payload);
    },

    setLoadingMessage({ commit }, payload) {
      commit("SET_LOADING_MESSAGE", payload);
    },
  },

  mutations: {
    toggleSidebar(state) {
      state.sidebarShowing = !state.sidebarShowing;
    },

    hideSidebar(state) {
      state.sidebarShowing = false;
    },

    showSidebar(state) {
      state.sidebarShowing = true;
    },

    SET_SHOW_LOADING_OVERLAY(state, payload) {
      state.showLoadingOverlay = payload;
    },

    SET_LOADING_MESSAGE(state, payload) {
      state.loadingMessage = payload;
    },
  },
};
